import React, { FC, Fragment, useEffect, useState } from 'react';
import OrderReviewPageActions from 'components/order-review/order-review-page-actions/order-review-page-actions.component';
import OrderReviewList from 'components/order-review/order-review-list/order-review-list.component';
import { OrderReviewFilterType, OrderSummary, ReviewOrders } from 'models/invoice';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const OrderReview: FC = () => {
    const { t: translate } = useTranslation(['orders']);
    const [orderReviewFilter, setOrderReviewFilter] = useState<OrderReviewFilterType>({} as OrderReviewFilterType);
    const [orderSummary, setOrderSummary] = useState<OrderSummary>();
    const [selectedReviewOrders, setSelectedReviewOrders] = useState<{ [key: string]: ReviewOrders }>({});

    useEffect(() => {
        const filters = JSON.parse(localStorage.getItem('reviewOrderListFilter') || '{}');
        setOrderReviewFilter(filters);
    }, []);

    const handleOrderReviewFilterChange = (orderReviewFilter: OrderReviewFilterType) => {
        setOrderReviewFilter(orderReviewFilter);
        localStorage.setItem('reviewOrderListFilter', JSON.stringify(orderReviewFilter));
    };

    const handleClear = () => {
        setSelectedReviewOrders({});
    };

    return (
        <Fragment>
            <Helmet>
                <title>{translate('orders:ORDER_REVIEW')} | Denthub</title>
            </Helmet>
            <OrderReviewPageActions
                onOrderReviewFilterChange={handleOrderReviewFilterChange}
                orderSummary={orderSummary || ({} as OrderSummary)}
                onClear={handleClear}
                orderReviewFilter={orderReviewFilter}
                selectedReviewOrders={Object.values(selectedReviewOrders)}
            />
            <OrderReviewList
                orderReviewFilter={orderReviewFilter}
                setOrderSummary={(orderSummary: OrderSummary) => setOrderSummary(orderSummary)}
            />
        </Fragment>
    );
};

export default OrderReview;
